<template>
  <v-card id="notifier" v-if="!isEmpty" flat class="transparent mr-3">
      <transition-group name="notification">
        <v-card v-for="item in getNotifications" :key="item.id" min-width="300" :color="item.color" class="mb-2">
          <v-list-item>
            <v-list-item-content class="white--text font-weight-medium">{{ item.title }}</v-list-item-content>
            <v-list-item-action class="my-0">
              <v-btn icon color="white--text" @click.stop="close(item.id)">
                <v-icon small color="white">fal fa-times</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
          <v-card-text class="pt-0">
            <p class="white--text text-xs-left caption mb-0">{{ item.message }}</p>
            <v-progress-linear v-if="item.progress"
              striped rounded
              color="white"
              height="10"
              :value="item.progress * 100"
            />
          </v-card-text>
        </v-card>
      </transition-group>
  </v-card>
</template>

<script>
export default {
  name: 'notifier',
  data () {
    return {
      config: {
      },
      meta: {
        icons: {
          message: ['fal', 'bell'],
          alert: ['fal', 'exclamation-triangle'],
          progress: ['fal', 'spinner-third']
        },
        colors: {
          success: 'green darken-1',
          info: 'blue darken-1',
          alert: 'red darken-4',
          error: 'red darken-4',
          progress: 'blue darken-1'
        },
        spins: [
          'progress'
        ]
      },
      store: {
        notifications: {}
      }
    }
  },
  methods: {
    close: function (id) {
      this.$store.commit('notifier/close', id)
    }
  },
  computed: {
    isEmpty () {
      return (this.store.notifications.length === 0)
    },
    getNotifications () {
      return this.$store.getters['notifier/list']().map(it => {
        return Object.assign(it, {
          color: it.type && this.meta.colors[it.type] ? this.meta.colors[it.type] : it.type
        })
      })
    }
  }
}
</script>

<style lang="scss">
#notifier {
  position: fixed;
  top: $header_h;
  right: 0;
  z-index: 999;
}

.notification-enter {
  opacity: 0;
}
.notification-enter-active {
  animation: fadeInRight .5s;
}
.notification-leave-active {
  opacity: 0;
}
.notification-leave-active {
  animation: fadeOutRight .5s;
}
@keyframes fadeInRight {
  from {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }

  to {
    opacity: 1;
    transform: translate3d(0, 0, 0);
  }
}
@keyframes fadeOutRight {
  from {
    opacity: 1;
  }

  to {
    opacity: 0;
    transform: translate3d(100%, 0, 0);
  }
}

</style>
